/**
 * ChopChop USA cart drawer extras
 * 1. "Clear cart" button above the drawer upsells
 * 2. Variant picker on cart lines (swaps the line to the chosen variant)
 *
 * Kaching Bundles links gifts/upsells to the main line through the hidden
 * `__kaching_bundles` line property, so a swap re-adds the line with the
 * exact same properties before removing the old one.
 */
(function () {
  if (window.__ccCartExtras) return;
  window.__ccCartExtras = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var DRAWER_SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok || data.status) throw data;
        return data;
      });
    });
  }

  function setBusy(busy) {
    var drawer = document.getElementById('CartDrawer');
    if (drawer) drawer.classList.toggle('cc-cart-busy', busy);
  }

  // Re-render the drawer + cart bubble with the theme's own renderer.
  // The full cart page has its own markup, so just reload it there.
  function render(data) {
    if (document.getElementById('main-cart-items')) {
      window.location.reload();
      return;
    }
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
      cartDrawer.renderContents(data, true);
    } else {
      window.location.reload();
    }
  }

  /* 1. Clear cart */
  document.addEventListener('click', function (event) {
    var button = event.target instanceof Element ? event.target.closest('[data-cc-clear-cart]') : null;
    if (!button) return;
    event.preventDefault();

    setBusy(true);
    postJSON(root + 'cart/clear.js', {
      sections: DRAWER_SECTIONS.join(','),
      sections_url: window.location.pathname,
    })
      .then(render)
      .catch(function (error) {
        console.error('[ChopChop] Clear cart failed', error);
        window.location.reload();
      })
      .finally(function () {
        setBusy(false);
      });
  });

  /* 2. Change variant */
  function decode(value) {
    var textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  }

  function readProperties(select) {
    var properties = {};
    try {
      var parsed = select.dataset.props ? JSON.parse(select.dataset.props) : {};
      // Liquid renders line properties as [[key, value], ...]
      if (Array.isArray(parsed)) {
        parsed.forEach(function (pair) {
          properties[pair[0]] = pair[1];
        });
      } else if (parsed) {
        properties = parsed;
      }
    } catch (e) {
      properties = {};
    }
    // Liquid HTML-escapes the values (" becomes &quot;). Kaching needs the raw JSON.
    Object.keys(properties).forEach(function (name) {
      if (typeof properties[name] === 'string') properties[name] = decode(properties[name]);
    });
    return properties;
  }

  // Capture phase: the theme's cart-drawer-items listens to `change` and would
  // treat the new variant id as a quantity. Stop the event before it gets there.
  document.addEventListener(
    'change',
    function (event) {
      var select = event.target;
      if (!(select instanceof HTMLSelectElement) || !select.classList.contains('cc-variant-select')) return;
      event.stopImmediatePropagation();

      var data = select.dataset;
      var newVariant = Number(select.value);
      if (!data.key || !newVariant || String(newVariant) === data.variant) return;

      var item = { id: newVariant, quantity: Number(data.qty) || 1, properties: readProperties(select) };
      if (data.sellingPlan) item.selling_plan = Number(data.sellingPlan);

      var oldVariant = Number(data.variant);
      var oldProps = JSON.stringify(item.properties);
      var keysBefore = [];

      setBusy(true);
      // Add the new variant first. If this fails, the original line is still in the cart.
      fetch(root + 'cart.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          keysBefore = cart.items.map(function (line) {
            return line.key;
          });
          return postJSON(root + 'cart/add.js', { items: [item] });
        })
        .then(
          function () {
            // Kaching re-writes bundle lines after an add, so the old key can change.
            // Find the old line again: same key, else same variant + same properties, else same variant.
            return fetch(root + 'cart.js')
              .then(function (r) {
                return r.json();
              })
              .then(function (cart) {
                var lines = cart.items;
                var sameVariant = lines.filter(function (line) {
                  return line.variant_id === oldVariant;
                });
                var target =
                  lines.find(function (line) {
                    return line.key === data.key;
                  }) ||
                  sameVariant.find(function (line) {
                    return JSON.stringify(line.properties || {}) === oldProps;
                  }) ||
                  sameVariant.find(function (line) {
                    return keysBefore.indexOf(line.key) !== -1;
                  }) ||
                  sameVariant[0];
                if (!target) return postJSON(root + 'cart/update.js', {
                  updates: {},
                  sections: DRAWER_SECTIONS.join(','),
                  sections_url: window.location.pathname,
                });
                return postJSON(root + 'cart/change.js', {
                  id: target.key,
                  quantity: 0,
                  sections: DRAWER_SECTIONS.join(','),
                  sections_url: window.location.pathname,
                });
              })
              .then(render)
              .catch(function (error) {
                console.error('[ChopChop] Removing old variant failed', error);
                window.location.reload();
              });
          },
          function (error) {
            console.error('[ChopChop] Variant change failed', error);
            select.value = data.variant;
            if (error && error.description) window.alert(error.description);
          }
        )
        .finally(function () {
          setBusy(false);
        });
    },
    true
  );
})();
